/**
 * nl/accordion — front-end toggle behaviour
 *
 * Each .nl-accordion-item__header button toggles its sibling
 * .nl-accordion-item__body. Multiple items can be open at once.
 */
(function () {
	'use strict';

	function initAccordions() {
		const headers = document.querySelectorAll('.nl-accordion-item__header');

		headers.forEach(function (header) {
			header.addEventListener('click', function () {
				const item   = header.closest('.nl-accordion-item');
				const body   = document.getElementById(header.getAttribute('aria-controls'));
				const isOpen = item.classList.contains('is-open');

				if (isOpen) {
					item.classList.remove('is-open');
					header.setAttribute('aria-expanded', 'false');
					body.hidden = true;
				} else {
					item.classList.add('is-open');
					header.setAttribute('aria-expanded', 'true');
					body.hidden = false;
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAccordions);
	} else {
		initAccordions();
	}
})();
